function parseMetadataError(
  fields: string[],
  msg: string,
): Record<string, unknown> {
  const fieldsString = fields.join('|');
  const regEx = new RegExp(`(${fieldsString})`, 'g');

  const level = /(variant|product)/g.exec(msg);

  const result: { [key: string]: string } = {};

  const errorMsg = msg
    .replace(new RegExp(`.*(${fieldsString})`), '')
    .replace(/,/g, '')
    .trim();

  let match;
  while ((match = regEx.exec(msg)) !== null) {
    result[match[1]] = `${match[1]} ${errorMsg}`;
  }

  return { level: level ? level[0] : 'product', ...result };
}

export default parseMetadataError;
